/**
 * Disconnect: `tenant_integrations_5`, or legacy roles that only define
 * `tenant_integrations_1`–`_4` where `_3` bundled "update / disconnect".
 *
 * If `tenant_integrations_5` exists on the role, only its `isEnabled` counts
 * (split permissions / re-saved roles).
 */
export function isTenantIntegrationDisconnectEnabled(userRole) {
  const map = userRole?.integrationPermissions
  if (map && typeof map === "object" && !Array.isArray(map)) {
    const granularDisconnect = Object.values(map).some(entry => {
      if (!entry || typeof entry !== "object") return false
      if (entry.tenant_integrations_5 === true) return true
      // Legacy bundled update/disconnect when _5 was never granted on this row.
      if (
        entry.tenant_integrations_5 !== true &&
        entry.tenant_integrations_5 !== false &&
        entry.tenant_integrations_3 === true
      ) {
        return true
      }
      return false
    })
    if (granularDisconnect) return true
  }

  if (!userRole?.permissions) return false
  const cat48 = userRole.permissions.find(
    r => Number(r.id) === 48 || r.id === 48
  )
  if (!cat48?.permissions) return false
  const row5 = cat48.permissions.find(p => p.id === "tenant_integrations_5")
  if (row5?.isEnabled) return true
  const row3 = cat48.permissions.find(p => p.id === "tenant_integrations_3")
  if (!row5 && row3?.isEnabled) return true
  return false
}
